import { RECALL_ACTIONS_FAIL } from '../types/global';

const initState = {
  actionsFailed: [],
};

const reducer = (state = initState, payload) => {
  const { type } = payload;
  switch (type) {
    case RECALL_ACTIONS_FAIL:
      return {
        ...state,
        actionsFailed: payload.action ? [...state.actionsFailed, payload.action] : [],
      };
    default:
      return state;
  }
};

export default reducer;
